<template>
    <!-- 合伙人管理-合伙人审核 -->
    <div class="container container-tabs">
        <el-tabs class="container-top" v-model="activeName" @tab-click="handleClick" type="card">
            <el-tab-pane name="all" class="to-searh">
                <span slot="label" class="table-title">全部</span>
            </el-tab-pane>

            <el-tab-pane :name="String(item.val)" v-for="(item, index) in value_status_array" :key="index" class="to-searh">
                <span slot="label" class="table-title">{{ item.alias }}</span>
            </el-tab-pane>
            <div class="handle-box">
                <el-row class="head-search">
                    <el-col :span="12" style="margin: 10px 0">
                        <span class="title">姓名/手机号 : </span>
                        <el-input
                            v-model="search_data.promoter_name_phone"
                            placeholder="请输入姓名/手机号 "
                            @keyup.enter.native="searchistributionPromoterList"
                            style="width: 200px"
                        ></el-input>
                    </el-col>
                    <el-col :span="12" style="margin: 10px 0">
                        <span class="title">申请时间 : </span>
                        <el-date-picker
                            v-model="search_time"
                            type="daterange"
                            range-separator="-"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            @change="timeChange"
                            style="width: 300px"
                        >
                        </el-date-picker>
                    </el-col>
                </el-row>
                <el-button type="primary" icon="el-icon-search" @click="searchistributionPromoterList">搜索</el-button>

                <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>

                <el-button type="primary" @click="addBtn('add')">添加合伙人</el-button>
            </div>
        </el-tabs>

        <div class="searchInfo">
            <div>
                <!-- 表格 -->
                <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header">
                    <el-table-column prop="id" label="id" min-width="80"> </el-table-column>

                    <el-table-column prop="promoter_name" label="姓名" min-width="100"> </el-table-column>

                    <el-table-column prop="promoter_phone" label="手机号" min-width="100"> </el-table-column>

                    <el-table-column prop="first_level_commission" label="一级提成比例" min-width="100"> </el-table-column>

                    <el-table-column prop="second_level_commission" label="二级提成比例" min-width="100"> </el-table-column>

                    <el-table-column prop="city_name" label="所属城市" min-width="100"> </el-table-column>

                    <el-table-column prop="parent.name" label="上级姓名" min-width="100"> </el-table-column>
                    <el-table-column prop="parent.phone" label="上级电话" min-width="100"> </el-table-column>

                    <el-table-column prop="remarks" label="备注信息" min-width="100"> </el-table-column>

                    <el-table-column prop="create_time" label="申请时间" min-width="100"> </el-table-column>

                    <el-table-column prop="promoter_status" label="状态" min-width="100"> </el-table-column>
                    <el-table-column label="操作" width="450">
                        <template slot-scope="scope">
                            <el-button
                                type="danger"
                                size="mini"
                                v-if="scope.row.promoter_status == '拒绝' || scope.row.promoter_status == '取消授权'"
                                @click="deleteData(scope.row)"
                                >删除</el-button
                            >

                            <el-button
                                size="mini"
                                type="warning"
                                v-if="scope.row.promoter_status == '通过'"
                                @click="changeDistributionPromoterStatus(scope.row, '3')"
                                >取消授权</el-button
                            >

                            <el-button size="mini" type="success" v-if="scope.row.promoter_status == '待审核'" @click="shouQuan(scope.row)"
                                >授权合伙人</el-button
                            >

                            <el-button
                                size="mini"
                                type="primary"
                                v-if="scope.row.promoter_status == '通过'"
                                @click="editDistributionPromote(scope.row)"
                                >修改上级合伙人</el-button
                            >

                            <el-button
                                size="mini"
                                type="info"
                                v-if="scope.row.promoter_status == '取消授权'"
                                @click="changeDistributionPromoterStatus(scope.row, '1')"
                                >重新授权</el-button
                            >
                            <el-button size="mini" type="primary" @click="editBtn(scope.row, 'edit')">编辑</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div
                    v-if="infoIsShow"
                    style="
                        z-index: 100;
                        background-color: #fff;
                        color: #606266;
                        border: 1px solid #ebeef5;
                        width: 420px;
                        height: 120px;
                        border-radius: 8px;
                        padding: 10px;
                        font-size: 16px;
                        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
                        position: relative;
                        left: 30%;
                        top: 20%;
                    "
                >
                    <!-- 授权合伙人弹框 -->
                    <div style="margin-bottom: 10px; font-size: 20px; font-weight: 700">提示</div>
                    <div style="margin-bottom: 10px">
                        <i class="el-icon-warning" style="color: #e6a23c"></i>
                        此操作将改变合伙人状态，请谨慎操作!
                    </div>
                    <div style="display: flex; justify-content: right">
                        <el-button size="mini" @click="closeBtn">关闭</el-button>

                        <el-button type="danger" @click="reject" size="mini">拒绝</el-button>
                        <el-button type="success" @click="success" size="mini">通过</el-button>
                    </div>
                </div>
            </div>

            <!-- 分页组件 -->
            <div class="pagination">
                <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
            </div>
        </div>

        <!-- 添加组件 -->
        <addDistributionPromoter :isShow="add_isShow" :data="editData" @onSubmit="searchistributionPromoterList"></addDistributionPromoter>

        <!-- 修改上级组件 -->
        <editDistributionPromoterParentCode
            :isShow="edit_isShow"
            :data="postData"
            @onSubmit="searchistributionPromoterList"
        ></editDistributionPromoterParentCode>
        <div
            v-if="infoIsShow"
            style="position: fixed; opacity: 0.5; background: #000; width: 100%; height: 100%; left: 0; top: 0; z-index: 99"
        ></div>
    </div>
</template>

<script>
var _this;
import addDistributionPromoter from './addDistributionPromoter.vue';
import editDistributionPromoterParentCode from './editDistributionPromoterParentCode.vue';

import bus from '@/components/common/bus.js';

export default {
    components: {
        addDistributionPromoter,
        editDistributionPromoterParentCode
    },
    data() {
        return {
            // 选项卡默认选中项
            activeName: 'all',
            shouQuanData: {},
            infoIsShow: false,
            postData: {},
            edit_isShow: false,
            search_time: [],

            // 传入子组件的数据
            editData: {},
            editPost: {},
            coordinates_code_status: 'add',

            add_isShow: false,

            // 下拉搜索城市
            value_city_code: '',
            options_city_code: [],

            company_name: '',

            // 下拉搜索管理状态
            value_status_array: [
                {
                    val: '0',
                    alias: '待审核'
                },
                {
                    val: '1',
                    alias: '通过'
                },
                {
                    val: '2',
                    alias: '拒绝'
                },
                {
                    val: '3',
                    alias: '取消授权'
                }
            ],

            // 存放表格数据
            tableData: [],

            //翻页数据
            search_data: {
                page: 1,
                limit: 10,
                promoter_name_phone: '',
                create_time: '',

                status: ''
            },

            result_data: [],
            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            }
        };
    },
    created() {
        _this = this;

        _this.searchistributionPromoterList();
    },

    methods: {
        // 申请时间查询
        timeChange(val) {
            if (val != null && val != '') {
                _this.search_data.create_time = JSON.stringify(['between'].concat(val));
            } else {
                _this.search_data.create_time = '';
            }
        },

        // 添加合伙人
        addBtn(e) {
            _this.editData.editFlag = e;
            _this.add_isShow = !_this.add_isShow;
        },
        // 编辑
        editBtn(e, val) {
            _this.editData.editFlag = val;

            _this.editData.promoter_code = e.promoter_code;

            _this.editData.city_name = e.city_name;

            _this.add_isShow = !_this.add_isShow;
        },

        //搜索
        searchistributionPromoterList() {
            _this.search_data.page = 1;
            _this.distributionPromoterList();
        },
        // 选项卡选中事件
        handleClick(tab, event) {
            // 点击的选项卡所对应的val值
            console.log(tab.name);
            if (tab.name != 'all') {
                _this.search_data.status = tab.name;
            } else {
                _this.search_data.status = '';
            }
            _this.search_data.page = 1;
            _this.distributionPromoterList();
        },

        // 搜索推荐地址列表
        distributionPromoterList() {
            _this
                .$post('/distribution/distributionPromoterList', _this.search_data, _this.search_rules)
                .then((res) => {
                    // 将请求的数据存放到表格数据数组中
                    _this.tableData = res.data;
                    _this.result_data = res;
                })
                .catch((err) => {});
        },

        //翻页组件的回调
        pages_function(search_data) {
            //赋值
            _this.search_data = search_data;
            //初始化列表
            _this.distributionPromoterList();
        },

        // 删除
        deleteData(val) {
            _this
                .$confirm('此操作将删除该条数据, 是否继续?', '提示', {
                    confirmButtonText: '确定',

                    cancelButtonText: '取消',

                    type: 'warning'
                })
                .then(() => {
                    _this
                        .$post('/distribution/delDistributionPromoter', {
                            promoter_code: val.promoter_code
                        })
                        .then((res) => {
                            _this.$message.success('删除成功!');

                            //初始化显示列表
                            _this.distributionPromoterList();
                        })
                        .catch((err) => {});
                })
                .catch(() => {
                    _this.$message.info('已取消');
                });
        },

        // 改变合伙人审核状态
        changeDistributionPromoterStatus(val, e) {
            _this
                .$confirm('此操作将改变合伙人状态, 是否继续?', '提示', {
                    confirmButtonText: '确定',

                    cancelButtonText: '取消',

                    type: 'warning'
                })
                .then(() => {
                    _this
                        .$post('/distribution/changeDistributionPromoterStatus', {
                            promoter_code: val.promoter_code,
                            promoter_status: e
                        })
                        .then((res) => {
                            _this.$message.success(res.msg);

                            //初始化显示列表
                            _this.distributionPromoterList();
                        })
                        .catch((err) => {});
                })
                .catch(() => {
                    _this.$message.info('已取消');
                });
        },

        // 授权合伙人弹窗关闭按钮
        closeBtn() {
            _this.infoIsShow = false;
        },
        // 授权合伙人弹框 拒绝按钮
        reject() {
            _this
                .$post('/distribution/changeDistributionPromoterStatus', {
                    promoter_code: _this.shouQuanData.promoter_code,
                    promoter_status: '2'
                })
                .then((res) => {
                    _this.$message.success(res.msg);

                    //初始化显示列表
                    _this.distributionPromoterList();
                    _this.infoIsShow = false;
                    _this.shouQuanData = {};
                })
                .catch((err) => {});
        },

        // 授权合伙人弹框 同意按钮
        success() {
            _this
                .$post('/distribution/changeDistributionPromoterStatus', {
                    promoter_code: _this.shouQuanData.promoter_code,
                    promoter_status: '1'
                })
                .then((res) => {
                    _this.$message.success(res.msg);

                    //初始化显示列表
                    _this.distributionPromoterList();
                    _this.infoIsShow = false;
                    _this.shouQuanData = {};
                })
                .catch((err) => {});
        },

        // 授权合伙人
        shouQuan(val) {
            _this.shouQuanData = val;
            _this
                .$confirm('此操作授权合伙人, 是否继续?', '提示', {
                    confirmButtonText: '确定',

                    cancelButtonText: '取消授权并关闭',

                    type: 'warning'
                })
                .then(() => {
                    _this
                        .$post('/distribution/changeDistributionPromoterStatus', {
                            promoter_code: _this.shouQuanData.promoter_code,
                            promoter_status: '1'
                        })
                        .then((res) => {
                            _this.$message.success(res.msg);

                            //初始化显示列表
                            _this.distributionPromoterList();
                            // _this.infoIsShow = false;
                            _this.shouQuanData = {};
                        })
                        .catch((err) => {});
                })
                .catch(() => {
                    _this
                        .$post('/distribution/changeDistributionPromoterStatus', {
                            promoter_code: _this.shouQuanData.promoter_code,
                            promoter_status: '2'
                        })
                        .then((res) => {
                            _this.$message.success(res.msg);

                            //初始化显示列表
                            _this.distributionPromoterList();
                            // _this.infoIsShow = false;
                            _this.shouQuanData = {};
                            _this.$message.info('已取消');
                        })
                        .catch((err) => {});
                    // _this.$message.info('已取消');
                });
            return;

            console.log(val, '授权合伙人');

            _this.infoIsShow = true;
            _this.shouQuanData = val;
        },

        // 修改上级合伙人
        editDistributionPromote(e) {
            console.log(e, 'e=');
            _this.edit_isShow = !_this.edit_isShow;
            _this.postData = e;

            console.log(_this.postData, '_this.postData');
        },

        //搜索的下拉框弹出触发
        cityVisibleChange(val) {
            // 请求公司管理接口获取公司唯一编码
            if (val) {
                _this
                    .$post('/city/cityLists', {
                        page: 1,
                        limit: 50,
                        name: ''
                    })
                    .then((res) => {
                        _this.options_city_code = res.data;
                    })
                    .catch((err) => {});
            }
        },

        // 刷新按钮
        refresh() {
            this.$router.go(0);
        }
    }
};
</script>

<style>
</style>